import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import "styles/master.css";
import React from "react";
import {Switch, Route, BrowserRouter } from "react-router-dom";
import HotelTravelLandingPage from "demos/HotelTravelLandingPage";
import {getRequests} from 'helpers/ApiHelper'
export default class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            seo: {},
            menus: [],
            pages: [],
            book_pages: [],
            footer_menus: [],
            info: {},
            logo: '',
            heading_tile: '',
            heading_info: '',
            footer_text: '',
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(changeObject) {
        this.setState(changeObject)
    }

    componentDidMount() {
        getRequests('web-setting').then(data => {
            const booking_pages = [
                    {
                        path:'/book-fleets',
                        route:'book-fleets'
                    },
                    {
                        path:'/book-passenger',
                        route:'book-passenger'
                    },
                    {
                        path:'/book-confirm',
                        route:'book-confirm'
                    },
                    {
                        path:'/book-payment',
                        route:'book-payment'
                    },
                    {
                        path:'/book-thank-you',
                        route:'book-thank'
                    }
                ];
            this.handleChange({
                menus: data.menus,
                pages: data.pages,
                book_pages: booking_pages,
                info: data.info,
                footer_menus: data.footer_menus,
                logo: data.info.cropped_image_url,
                heading_tile: data.info.name,
                heading_info: data.info.info,
                footer_text: data.info.footer_text,
            });
        });
    }

    render() {
        const basename =  '/';
        return (
            <BrowserRouter  basename={basename}>
                <Switch>
                    {this.state.book_pages.map((book_page, index) => {
                        return <Route key={index} path={book_page.path}>
                            <HotelTravelLandingPage key={index} pageData={this.state}  currentRoute={book_page.route}/>
                        </Route>

                    })}
                    {this.state.pages.map((page, index) => {
                        if(page.slug !== 'home'){
                            return <Route key={index} path={'/' + page.slug}>
                                <HotelTravelLandingPage pageData={this.state}  currentRoute={page.slug}/>
                            </Route>
                        }
                        return null;
                    })}
                    {this.state.pages.map((page, index) => {
                        if(page.slug === 'home'){
                            return <Route key={index} path='/'>
                                <HotelTravelLandingPage pageData={this.state} currentRoute="home"/>
                            </Route>
                        }
                        return null; 
                    })}
                </Switch>
            </BrowserRouter>

        );
    }
}
